import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { MainBody } from './relatorio-fluxo-lista-styled';
import { BaSeParagraph, BaSeSmall1 } from '@base/react';
import { FlexedJC } from './relatorio-fluxo-consolidado-styled';

const DEFAULT_COLOR_TEXT = '#243342';

const ShowMoney = ({ value, forceNegative }) => {
  const money = Sebrae.useMask(parseFloat(value ?? '0').toFixed(2), 'decimal');
  const isZero = React.useMemo(() => money === '0,00', [money]);
  const color = React.useMemo(() => {
    if (isZero) {
      return DEFAULT_COLOR_TEXT;
    }
    if (forceNegative) {
      return '#B22400';
    }
    return money.includes('-') ? '#B22400' : '#008537';
  }, [forceNegative, isZero, money]);

  const negative = React.useMemo(
    () => (forceNegative || money.includes('-') ? '-' : ''),
    [money, forceNegative],
  );

  return (
    <BaSeSmall1 color={color}>
      {negative} R$ {money.replace('-', '')}
    </BaSeSmall1>
  );
};

export const RelatorioFluxoConsolidado = ({ broken, dados }) => {
  const hasExpansesNegative = dados?.totalDespesas > 0;
  return (
    <>
      {broken && (
        <BaSeSmall1 color="#243342">
          *O período selecionado pode não incluir todos os lançamentos
          referentes a esse mês.
        </BaSeSmall1>
      )}
      <MainBody broken={broken}>
        <FlexedJC>
          <BaSeParagraph isBold color={DEFAULT_COLOR_TEXT}>
            Consolidado
          </BaSeParagraph>
        </FlexedJC>
        <FlexedJC>
          <BaSeSmall1 isBold color={DEFAULT_COLOR_TEXT}>
            Saldo anterior
          </BaSeSmall1>
          <ShowMoney value={dados?.saldoAnterior} />
        </FlexedJC>
        <FlexedJC>
          <BaSeSmall1 isBold color={DEFAULT_COLOR_TEXT}>
            Total de receitas no período
          </BaSeSmall1>
          <ShowMoney value={dados?.totalReceitas} />
        </FlexedJC>
        <FlexedJC>
          <BaSeSmall1 isBold color={DEFAULT_COLOR_TEXT}>
            Total de despesas no período
          </BaSeSmall1>
          <ShowMoney
            value={dados?.totalDespesas}
            forceNegative={hasExpansesNegative}
          />
        </FlexedJC>
        <FlexedJC>
          <BaSeSmall1 isBold color={DEFAULT_COLOR_TEXT}>
            Saldo do período
          </BaSeSmall1>
          <ShowMoney value={dados?.saldoPeriodo} />
        </FlexedJC>
        <FlexedJC last>
          <BaSeSmall1 last isBold color={DEFAULT_COLOR_TEXT}>
            Saldo final
          </BaSeSmall1>
          <ShowMoney value={dados?.saldoFinal} />
        </FlexedJC>
      </MainBody>
    </>
  );
};
